import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=6121bab0&scoped=true"
import script from "./OrderAddress.vue?vue&type=script&lang=js"
export * from "./OrderAddress.vue?vue&type=script&lang=js"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=6121bab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121bab0",
  null
  
)

export default component.exports